import React from 'react';
import { Pencil } from '@upstart/harmony/lib/legos/pencilTypes';
import { JsonLinks } from './JsonLinks';
import './LendingSupport.scss';

interface Props {
  onClick: (pencil?: object) => void;
  pencils?: Pencil[] | null;
}

export const LendingSupportPencils: React.FC<Props> = ({
  pencils,
  onClick,
}) => (
  <>
    <div>Pencils:</div>
    <div className="lending-support-pencils-container">
      <JsonLinks
        dataList={pencils}
        getName={(_, index) => `pencil${(pencils?.length ?? 0) - index}`}
        onClick={onClick}
      />
    </div>
  </>
);
